import styled from 'styled-components';

export const Container = styled.div`
  background: #f5f5f5;
  input {
    height: 40px;
    border-radius: 4px;
    border: solid 1px #f17531;
    &:focus {
      border-color: red;
    }
  }
`;

export const QuestionnaireList = styled.ul(
	({ theme: { down, breakpoints } }) => `
    
          ${down(breakpoints.md)} {
              flex-wrap: wrap;
              margin-bottom: 20px;
          }
          display: flex;
          margin-bottom: 37px;
          > li{
            ${down(breakpoints.md)} {
                width: 100%;
                margin-bottom: 10px;
  
            }
            &.active{
              background-color: #f17531;
              color: #fff;
              font-weight: bold;
            }
            position: relative;
            cursor: pointer;
            border-radius: 4px;
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
            padding:12px;
            margin-right: 10px;
          }
      
        `
);

export const QuestionnaireWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
    
          ${down(breakpoints.md)} {
              flex-wrap: wrap;
          }
          display: flex;
          align-items: start;
          justify-content: space-between;
      
        `
);

export const QuestionnaireLeftWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
  
        ${down(breakpoints.md)} {
            width:100%;
        }
        width:79%;
    
      `
);

export const QuestionnaireRightWrap = styled.article(
	({ theme: { down, breakpoints } }) => `
    
          ${down(breakpoints.md)} {
              width:100%;
          }
          width:53%;
      
        `
);

export const BtnWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
    
          ${down(breakpoints.md)} {
            display: flex;
            flex-direction: column-reverse;
              >button{
                width: 100%;
                &:last-child{
                  margin-bottom: 10px;
                  margin-right:0;
                }
                &:first-child{
                  margin-right:0;
                }
                
              }
          }
          >button{
            &:first-child{
              margin-right:10px;
            }
          }

      
        `
);

export const BottomModalInnerWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
    ${down(breakpoints.md)} {
      padding: 0;
    }
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
    padding: 50px 16px;
    `
);

export const Progress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background: #f17531;
  border-radius: 0 2px 2px 0;
  width: ${(props) => (props.que / props.total) * 100}%;
`;
